import { STATE_STATUSES, getEventStateStatus } from '@nv/utils'
import CountdownTimerBig from './CountdownTimerBig'
import CountdownTimerSmall from './CountdownTimerSmall'
import FormattedDate from './FormattedDate'

const CountdownTimer = (props) => {
  const { size } = props
  if (size === 'small') {
    return <CountdownTimerSmall {...props} />
  }
  return <CountdownTimerBig {...props} />
}

export const EventCountdownTimeDateContainer = ({ event, votingOpen, size = 'big', layout, hideFormattedDate = false }: any) => {
  const eventStateStatus = getEventStateStatus(event.state, votingOpen, event.nominationState)

  switch (eventStateStatus) {
    case STATE_STATUSES.nominationUpcoming:
      return (
        <CountdownTimer size={size} countDownDate={event.nominationOpenDate} status={STATE_STATUSES.nominationUpcoming} layout={layout} />
      )

    case STATE_STATUSES.nominationStarted: {
      return (
        <CountdownTimer size={size} countDownDate={event.nominationCloseDate} status={STATE_STATUSES.nominationStarted} layout={layout} />
      )
    }
    case STATE_STATUSES.nominationClosed:
      if (hideFormattedDate) {
        return <div />
      }
      return <FormattedDate date={event.nominationCloseDate} status={STATE_STATUSES.nominationClosed} size={size} />
    case STATE_STATUSES.upcoming:
      return <CountdownTimer size={size} countDownDate={event.openDate} status={STATE_STATUSES.upcoming} layout={layout} />
    case STATE_STATUSES.active:
      return <CountdownTimer size={size} countDownDate={event.closeDate} status={STATE_STATUSES.active} layout={layout} />
    case STATE_STATUSES.closed:
      if (hideFormattedDate) {
        return <div />
      }
      return <FormattedDate date={event.closeDate} status={STATE_STATUSES.closed} size={size} />
  }
}
export default EventCountdownTimeDateContainer
